import { clientApi } from 'shared/api/clientApi'
import { Response } from 'shared/models/general'

import {
  AutoRefundCheckData,
  AutoRefundCheckRequest,
  AutoRefundProcessData,
  AutoRefundProcessRequest,
} from './AutoRefundModel'

export const AutoRefundApi = {
  checkAutoRefund(data: AutoRefundCheckRequest) {
    return clientApi.post<Response<AutoRefundCheckData>>(
      '/flights/auto-refund/check',
      data,
    )
  },

  processAutoRefund(data: AutoRefundProcessRequest) {
    return clientApi.post<Response<AutoRefundProcessData>>(
      '/flights/auto-refund/process',
      data,
    )
  },
}
